const menuPrinting = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
        <g stroke="#F5F5F5" stroke-linejoin="round">
          <path stroke-linecap="round" d="M4.125,12.375 L1.875,12.375 C1.05,12.375 0.375,11.7 0.375,10.875 L0.375,6.375 C0.375,5.54925 1.05,4.875 1.875,4.875 L16.125,4.875 C16.95,4.875 17.625,5.54925 17.625,6.375 L17.625,10.875 C17.625,11.7 16.95,12.375 16.125,12.375 L13.875,12.375"/>
          <polyline stroke-linecap="round" points="4.125 3.375 4.125 .375 11.625 .375 13.875 2.625 13.875 3.375"/>
          <rect width="9.75" height="7.5" x="4.125" y="10.125" stroke-linecap="round"/>
          <circle cx="2.625" cy="7.125" r="1" stroke-linecap="round"/>
          <polyline stroke-linecap="round" points="11.625 .375 11.625 2.625 13.875 2.625"/>
          <polygon points="12.344 16.125 10.737 12.225 9 14.819 7.171 13.316 5.719 16.125"/>
          <circle cx="6.513" cy="11.838" r="1"/>
        </g>
        <rect width="18" height="18"/>
      </g>
    </svg>
`;

export default menuPrinting;
